module.exports = __webpack_public_path__ + "8f7e05b2076ef997b733045f8a01ab41.png";